module.exports = __webpack_public_path__ + "img/ANT.97c6599b.svg";